export default __webpack_public_path__ + "static/media/remi-vieille.a03c2708.jpg";